import { WrenchIcon } from '@heroicons/react/16/solid';
import { DateTime } from 'luxon';

export type ImportantMessage = {
  id: string;
  title: string;
  icon: React.ElementType;
  showUntil: DateTime;
  showFrom: DateTime;
  message: string;
};

export const IMPORTANT_MESSAGES: ImportantMessage[] = [
  {
    id: '1',
    title: 'Planerat servicefönster söndag 23/3',
    icon: WrenchIcon,
    showUntil: DateTime.fromISO('2025-03-24T00:00:00Z'),
    showFrom: DateTime.fromISO('2025-03-18T12:00:00Z'),
    message:
      'För att uppgradera vår prestanda planeras en uppdatering som innebär att våra tjänster kommer vara nere på söndag kväll. Våra tjänster kommer vara tillbaka igen på måndag morgon.',
  },
  {
    id: '2',
    title: 'Planerat servicefönster tisdag 25/8',
    icon: WrenchIcon,
    showUntil: DateTime.fromISO('2026-08-26T00:00:00Z'),
    showFrom: DateTime.fromISO('2025-08-25T12:00:00Z'),
    message:
      'I samband med systemuppdateringen ikväll så kommer vi att behöva stänga ner våra system under ett par timmar. Arbetet beräknas påbörjas 18:00 och fortsätta till ungefär 22:00. Våra tjänster kommer vara igång som vanligt imorgon onsdag. Vi ser fram emot att leverera allt som vi jobbat med i sommar!',
  },
];
